<template>
  <m-board :title="$t('account.profile.password-change.title')">
    <form class="form" @submit.prevent="change">
      <input class="hidden" type="submit" />
      <div class="board-form-element">
        <div class="board-form-element-key">
          <label for="password-recovery-prev">{{ $t('account.profile.password-change.current') }}</label>
        </div>
        <div class="board-form-element-value">
          <input id="password-recovery-prev" type="text" v-model="prev" v-on:keyup="clearMessages" />
        </div>
      </div>
      <div class="board-form-element">
        <div class="board-form-element-key">
          <label for="password-recovery-next">{{ $t('account.profile.password-change.new') }}</label>
        </div>
        <div class="board-form-element-value">
          <input id="password-recovery-next" type="text" v-model="next" v-on:keyup="clearMessages" />
        </div>
      </div>
      <div class="board-form-element">
        <div class="board-form-element-key">
          <label for="password-recovery-repeat">{{ $t('account.profile.password-change.repeat') }}</label>
        </div>
        <div class="board-form-element-value">
          <input id="password-recovery-repeat" type="text" v-model="repeat" v-on:keyup="clearMessages" />
        </div>
      </div>
      <div class="board-form-error-message board-form-message" v-if="error" v-html="error" />
      <div class="board-form-success-message board-form-message" v-if="success" v-html="success" />
      <div class="form-actions">
        <color-button color="yellow" @click="change">{{ $t('account.profile.password-change.submit') }}</color-button>
      </div>
    </form>
  </m-board>
</template>

<script>
import MBoard from '@/components/MBoard'
import ColorButton from '@/components/buttons/ColorButton'
import AuthenticationService from '@/services/AuthenticationService'

export default {
  components: { MBoard, ColorButton },
  data () {
    return {
      prev: '',
      next: '',
      repeat: '',
      error: null,
      success: null
    }
  },
  methods: {
    clearMessages () {
      this.error = null
      this.success = null
    },
    async change () {
      this.error = null
      this.success = null
      try {
        const response = await AuthenticationService.password({
          prev: this.prev,
          next: this.next,
          repeat: this.repeat
        })
        this.prev = ''
        this.next = ''
        this.repeat = ''
        this.success = response.data.success
      } catch (error) {
        this.error = error.response.data.error
      }
    }
  }
}
</script>

<style scoped>
.form { padding: 10px 0; }
.form-actions .color-button { left: 50%; margin-left: 5px; }
.board-form-message { margin: 0 10px 10px; text-align: center; }
</style>



// WEBPACK FOOTER //
// src/components/account/profile/PasswordChange.vue